<template>
  <div class="breadcrumb-container">
    <i style="vertical-align: 26px;font-size: 14px!important; margin-right: 2px;opacity: 0.8;" class="icon-nav"></i>
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="item in levelList" :key="item.path" v-show='item.meta.title'>
          <span class="no-redirect">{{$t(`route.${item.meta.title}`)}}</span>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      const matched = this.$route.matched.filter(item => item.meta.title)
      this.levelList = matched
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 65px;
    .no-redirect {
      color: white;
      cursor: text;
      opacity: 0.8;
    }
  }
</style>
<style rel="stylesheet/scss" lang="scss">
  .app-breadcrumb.el-breadcrumb {
    .el-breadcrumb__inner{
      a{
        color: white;
        opacity:0.8;
      }
    }
    .el-breadcrumb__separator{
      color: white;
      opacity: 0.8;
    }
  }
  .breadcrumb-container{
    display: inline-block;
    height: 100%;
  }
  .breadcrumb-icon-container{
    display: inline-block;
    height: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue